import { Plugins, Directives } from "@frontiers-vue3/public-pages";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Plugins.GoogleAnalyticsPlugin);
  nuxtApp.vueApp.directive("popover", Directives.Popover);
});
